let base_path = '/fg/';
let host = process.env.NODE_ENV === 'production' ? 'https://fg.plus' : 'http://localhost:8080';
host = 'https://fg.plus';
let imageRes = process.env.NODE_ENV === 'production' ? '/res/' : (host + '/res/')
let imageTmp = process.env.NODE_ENV === 'production' ? '/tmp/' : (host + '/tmp/')
let authHost = host
let url = host + base_path
export const config = {
  host: host,
  hostTitle: 'FG',
  location: 'fg',
  apiUrl: url,
  authUrl: authHost + base_path + 'cabinet/login',
  socialUrl: authHost + base_path + 'cabinet/social/',
  registerUrl: authHost + base_path + 'cabinet/register',
  confirmUrl: authHost + base_path + 'cabinet/confirm',
  passRestore: authHost + base_path + 'cabinet/restore',
  socialRedirect: authHost + '/social/redirect/',
  facebook: {
    id: '726820447901339',
    version: 'v11.0',
		scope: 'public_profile,email'
  },
  vk: {
    id: '7596091',
    version: '5.124',
    scope: 'email'
  },
  google: {
    //id: '132452024010-tlg7i65cm4g4a8bljo8a9eemlvvf75jb.apps.googleusercontent.com',
    id: '132452024010-t0bq1q98a7otfask9grdg460r58hs0h0.apps.googleusercontent.com',
    key: 'AIzaSyCeNHr7W1rOJfrT29aHpka0XJ8vXgdDkCw',
    scope: 'https://www.googleapis.com/auth/userinfo.email',//'https://www.googleapis.com/auth/drive.metadata.readonly',
    docs: ['https://www.googleapis.com/discovery/v1/apis/drive/v3/rest']
  },
  yandex: {
    id: '791da06dc2ca487bb9bdc24ee7a6d9f6',
    passowrd: 'a19b04571c484b7baee95ed819db4d22'
  },
  mailru: {
    id: 'fdeb30f343374d53ae945e047b1ea720',
    secret: '8036f81d907047e397befec6031ccc7d'
  },
  links: {
    vk: 'https://vk.com/freedom_guide',
    facebook: 'https://www.facebook.com/FGPlus-105051355063325/',
    instagram: 'https://www.instagram.com/fgplus_/',
    telegram: 'https://t.me/+pmrheO6Gk15mYTcy',
    zen: 'https://zen.yandex.ru/id/60d190c27937c35050fb78f4',
    youtube: 'https://www.youtube.com/channel/UCjuSg3BPc-_wxyp2Zvuyrmw'
  },
  tinkoff: '1603882823406DEMO',
  image: (name) => `${imageRes}${name}`,
  temp: (name) => `${imageTmp}${name}`,
  file: (path, id, file_id) => `${url}${path}/${id}/file/${file_id}`
}
